import { api } from '@/config'
import httpApi from '@/util/http-api'

export default {
  getLocations: () => {
    return httpApi.getDataViaApi(api.locations)
  }
}
